const LockedPreview = ({ seed = 0 }) => {
  const paths = [];
  const n = 5;
  for (let i = 0; i < n; i++) {
    const amp = 10 + ((seed * 7 + i * 3) % 12);
    const phase = (seed * 11 + i * 17) % 360;
    const d = Array.from({ length: 40 }, (_, k) => {
      const x = (k / 39) * 100;
      const y =
        40 +
        Math.sin((k / 39) * Math.PI * 3 + (phase * Math.PI) / 180) * amp * 0.6 +
        i * 1.5;
      return `${k === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`;
    }).join(' ');
    paths.push(d);
  }
  return (
    <svg
      viewBox="0 0 100 80"
      preserveAspectRatio="none"
      className="absolute inset-0 w-full h-full"
      aria-hidden="true"
    >
      {paths.map((d, i) => (
        <path
          key={i}
          d={d}
          fill="none"
          stroke={i === 0 ? '#e10600' : '#4b4b4b'}
          strokeWidth="0.6"
          opacity={i === 0 ? 0.7 : 0.4}
        />
      ))}
    </svg>
  );
};

export default LockedPreview;
